// src/store/modules/org.js
import apiClient from '@/axios';
import router from '@/router';
import { message } from "ant-design-vue";

const state = {
  casesData: {},
  casesViewData: [],
  casesDropdowns: [],
};

const getters = {
  getcasesDropdowns: (state) => state.casesDropdowns,
  getcasesData: (state) => state.casesData,
  getcasesViewData: (state) => state.casesViewData,
};

const mutations = {
  SET_CASES_DROPDOWNS_DATA(state, data) {
    state.casesDropdowns = data;
  },
  SET_CASES_DATA(state, data) {
    state.casesData = data;
  },
  SET_cases_VIEW_DATA(state, data) {
    state.casesViewData = data;
  },
};

const actions = {
  async fetchcasesOptions({ commit }) {
    try {
      const response = await apiClient.get('/settings/ticket');
      if (response.data.status) {
        commit('SET_CASES_DROPDOWNS_DATA', response.data.data.dropdowns);
        return response.data.data.dropdowns;
      }
    } catch (error) {
      console.error('Error fetching pipeline:', error);
    }
  },
  async fetchCases({ commit }, params) {
    try {
      const response = await apiClient.get('/tickets/list', { params });
      commit('SET_CASES_DATA', response.data.data);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching contracts data:', error);
    }
  },

  async fetchCasesAll({ commit }, params) {
    try {
      const response = await apiClient.get('/admin/tickets/list', { params });
      // commit('SET_CASES_DATA', response.data.data);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching contracts data:', error);
    }
  },

  async fetchCase({ commit }, id) {
    try {
      const response = await apiClient.get(`/tickets/view/${id}`);
      return response.data
    } catch (error) {
      console.error('Error fetching contract data:', error);
    }
  },
  async fetchAdminCase({ commit }, id) {
    try {
      const response = await apiClient.get(`/admin/tickets/view/${id}`);
      return response.data
    } catch (error) {
      console.error('Error fetching contract data:', error);
    }
  },
  async createCase({ commit }, form) {
    try {
      const response = await apiClient.post(
        '/tickets/create',
        form,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response.data;
    } catch (error) {
      message.error(error?.response?.data?.message)
      console.error('Error saving Activities data:', error);
    }
  },
  async updateCase({ commit }, { id, formData }) {
    try {
      const response = await apiClient.post(
        `/tickets/update/${id}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error updating contract data:', error);
    }
  },

  async updateAdminCase({ commit }, { id, formData }) {
    try {
      const response = await apiClient.post(
        `/admin/tickets/update/${id}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error updating contract data:', error);
    }
  },

  async deleteCase({ commit }, id) {
    try {
      const response = await apiClient.delete(
        `/tickets/delete-ticket/${id}`
      );
      return response.data;
    } catch (error) {
      console.error('Error updating contract data:', error);
    }
  },

  async deleteDocument({ commit }, id) {
    try {
      const response = await apiClient.delete(
        `/tickets/document/${id}`
      );
      return response.data;
    } catch (error) {
      console.error('Error updating contract data:', error);
    }
  },

  async uploadDocument({ commit }, {caseId,formData}) {
    try {
      const response = await apiClient.post(
        `/tickets/upload/documents/${caseId}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response.data;
    } catch (error) {
      message.error(error?.response?.data?.message)
      console.error('Error updating contract data:', error);
    }
  },

  async addComment({ commit, rootGetters }, {formData,id}) {
    try {


      const user = rootGetters['auth/user'];
      let response;
      if(user?.roles[0] === 'super_admin'){
        response = await apiClient.post(
          `/admin/tickets/save/reply/${id}`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        );
      } else {
        response = await apiClient.post(
          `/tickets/save/reply/${id}`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        );
      }
      return response.data;
    } catch (error) {
      message.error(error?.response?.data?.message)
      console.error('Error saving Activities data:', error);
    }
  },

};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
